import { StartIssuanceResponse } from "../../containers/quotation/types/emission";

export type EmissionState = {
    idTransaction: number;
    numberQuotes: number;
    registerResponse: { urlSafetyPay: string; status: string };
    startIssuance: StartIssuanceResponse;
    loadingSafetyPayCode: boolean;
};

export const emissionDefaultState: EmissionState = {
    idTransaction: null,
    numberQuotes: null,
    registerResponse: null,
    startIssuance: null,
    loadingSafetyPayCode: false,
};
